<template>
	<div class="information">
		<header-simple :title="$t('base.profile.information')" :subtitle="'Information about the user account.'"></header-simple>
		<spinner v-if="model.loading"/>
		<detail-panel v-if="model.data">
			<detail-panel-item :label="$t('labels.auth.fullname')" :value="model.data.fullname" />
			<detail-panel-item :label="$t('labels.auth.email')" :value="model.data.email" />
		</detail-panel>
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import HeaderSimple from '@/modules/ui/HeaderSimple'
import DetailPanel from '@/modules/ui/DetailPanel'
import DetailPanelItem from '@/modules/ui/DetailPanelItem'
export default {
	props: [
		'user_uid'
	],
	components: {
		HeaderSimple,
		DetailPanel,
		DetailPanelItem
	},
	data () {
		return {
			model: new ApiObject()
		}
	},
	methods: {
		getUser () {
			this.model.loading = true
			this.model.data = null
			this.$api.users.getByUid(this, this.user_uid)
				.then(response => {
					this.$log.info('account information', 'users.getByUid OK', response)()
					this.model.data = response.body
				})
				.catch(error => {
					this.$log.error('account information', 'users.getByUid ERROR', error)()
					this.model.error = error
				})
				.finally(() => {
					this.model.loading = false
				})
		}
	},
	mounted () {
		this.getUser()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/accountinformation/Information.vue